import { THEME } from "@/3514/theme"

import {
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyWeight
} from "./typography.types"

const sizesMap: { [K in ETypographySize]: string } = {
    [ETypographySize.Tiny]: "text-[12px] leading-[18px]",
    [ETypographySize.ExtraSmall]: "text-[13px] leading-[20px]",
    [ETypographySize.Small]: "text-[14px] leading-[21px]",
    [ETypographySize.Medium]: "text-[16px] leading-[24px]",
    [ETypographySize.MediumPlus]: "text-[18px] leading-[27px]",
    [ETypographySize.Heading2]: "text-[24px] leading-[36px]",
    [ETypographySize.Heading1]: "text-[36px] leading-[54px]"
}

const colorsMap: { [K in ETypographyColor]: string } = {
    [ETypographyColor.Accent]: "text-accent",
    [ETypographyColor.Black]: "text-gray-100",
    [ETypographyColor.White]: "text-white",
    [ETypographyColor.Dark]: "text-gray-200",
    [ETypographyColor.Gold]: "text-red-300",
    [ETypographyColor.Error]: "text-red-100",
    [ETypographyColor.Gray23]: "text-gray-23",
    [ETypographyColor.Gray300]: "text-gray-300",
    [ETypographyColor.Gray500]: "text-gray-500",
    [ETypographyColor.Blue200]: "text-blue-200",
    [ETypographyColor.Blue300]: "text-blue-300",
    [ETypographyColor.Blue500]: "text-blue-500"
}

const fontWeightsMap: { [K in ETypographyWeight]: string } = {
    [ETypographyWeight.Default]: "font-[300]",
    [ETypographyWeight.Medium]: "font-[400]",
    [ETypographyWeight.Semibold]: "font-[600]",
    [ETypographyWeight.Bold]: "font-[800]"
}

const alignmentMap: { [A in ETypographyAlignment]: string } = {
    [ETypographyAlignment.Left]: "text-left",
    [ETypographyAlignment.Center]: "text-center",
    [ETypographyAlignment.Right]: "text-right"
}

const familiesMap: { [F in ETypographyFamily]: string } = {
    [ETypographyFamily.Nunito]: "font-nunito",
    [ETypographyFamily.DmSerif]: "font-serifDisplay"
}

const lineHeightMap: { [S in ETypographySize]: number } = {
    [ETypographySize.Tiny]: THEME.LINE_HEIGHTS[18],
    [ETypographySize.ExtraSmall]: THEME.LINE_HEIGHTS[20],
    [ETypographySize.Small]: THEME.LINE_HEIGHTS[21],
    [ETypographySize.Medium]: THEME.LINE_HEIGHTS[24],
    [ETypographySize.MediumPlus]: THEME.LINE_HEIGHTS[27],
    [ETypographySize.Heading2]: THEME.LINE_HEIGHTS[36],
    [ETypographySize.Heading1]: THEME.LINE_HEIGHTS[54]
}

const typographyConfig = { sizesMap, colorsMap, fontWeightsMap, alignmentMap, familiesMap, lineHeightMap }

export { typographyConfig }
